<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5" cols="12" align="center">
				<v-col class="ma-0 pa-0 mt-15" cols="12" id="group_box">
					<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
						{{ 'カメラグループ作成' }}
					</v-col>
					<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12" align="left">
						<!-- 그룹명 입력 -->
						<v-col class="ma-0 pa-0 pb-2" cols="12">{{ 'グループ名を入力' }}</v-col>
						<v-col class="ma-0 pa-0 pb-5" cols="12">
							<input class="group_input" placeholder="" style="width:100%;height:2rem;"
								v-model="groupName">
						</v-col>
						<!-- 카메라 선택 (공용 컴포넌트) -->
						<v-col class="ma-0 pa-0 pb-2" cols="12">{{ 'グループに追加したいカメラを選んでください。' }}</v-col>
						<CameraTreeSelect v-model="selectedCameras" />
						<!-- 돌아가기 / 작성하기 -->
						<v-col class="ma-0 pa-0 mt-5" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<v-btn width="8rem" height="auto" class="ma-0 pa-2 mr-3"
									id="grey_btn" elevation="0" @click="cancelGroup">
									{{ t('back') }}
								</v-btn>
								<v-btn width="8rem" height="auto" class="blue_btn ma-0 pa-2"
									id="blue_btn3" elevation="0" @click="makeGroup" :loading="addLoading">
									{{ t('create') }}
								</v-btn>
							</v-row>
						</v-col>
					</v-col>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import CameraTreeSelect from '@/components/CameraTreeSelect.vue';
export default {
	components: {
		CameraTreeSelect
	},
	mixins: [mixin.common],
	data: () => ({
		groupName: '',
		selectedCameras: [],  // 선택된 카메라 목록 (CameraTreeSelect v-model)
		addLoading: false,
	}),
	methods: {
		cancelGroup() {
			this.$router.back();
		},
		makeGroup() {
			if (this.groupName == '') {
				this.showToastMessage(this.tmb('requiredGroupName'));
				return;
			} else if (this.checkStringBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			} else if (this.checkStringOnlyBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			// 최초 생성 시에는 선택된 카메라가 없어도 그룹 생성을 허용한다 (그룹명만 필수).
			this.requestAddCameraGroup();
		},
		// 기입한 그룹명 + 선택한 카메라리스트를 /store/camera-group POST 로 전송해 카메라그룹을 생성한다.
		requestAddCameraGroup() {
			this.addLoading = true;
			const params = {
				groupName: this.groupName,
				cameras: this.selectedCameras.map((cam) => ({
					cameraName: cam.cameraName,
					contractCd: cam.contractCd,
					portNo: cam.portNo,
					unisCustomerCd: cam.unisCustomerCd,
					thingType: cam.thingType,
					size: 1, // 뷰크기 1(소) 초기값
				})),
			};
			this.networkController.addCameraCheckListGroup(params)
				.then((res) => {
					const groupData = res.data;
					console.log('%cAdd Camera Group\n', "color:#008DD0;", groupData);
					// 좌측 네비 카메라그룹 목록 갱신 (/store/camera-group GET)
					this.networkController.getCameraGroupList({}).then((listRes) => {
						this.$store.commit('setCameraGroupList', (listRes && listRes.data) || []);
					}).catch(() => { });
					this.showToastMessage(this.tmb('successAddGroup'));
					this.addLoading = false;
					// 생성된 그룹의 카메라그룹 페이지(카메라리스트 탭)로 이동
					this.pushRoute('/camera-group/detail', { groupId: groupData.id });
				}).catch((error) => {
					this.showToastMessage(this.tmb('requestFail'));
					this.addLoading = false;
				});
		},
	}
}
</script>

<style lang="scss" scoped>
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 1rem;
}
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	font-size: 0.9rem;
	font-weight: bold;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
}
.group_input {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 4px;
	color: white;
	padding: 5px;
}
</style>
